<div class="white-bg p-1">
  <div class="input py-0 " [class.d-md-flex]="!compact">
    <div class="flex-fill d-flex p-1 pointer no-wrap-ellipsis">
      <div class=" flex-fill no-wrap-ellipsis" [class.order-md-1]="!compact">
        <app-autocomplete #keywordSelector name="q" maxlength="512" [(ngModel)]="value.q" appendResultsTo="body"
          [searchIcon]="false" [clearIcon]="false" class="no-border no-shadow" [max-suggest]="10"
          [placeholder]="queryPlaceholder" (selected)="search('keyword',$event)"
          [searchTypes]="['jobtitle','skill','education','subscribe', 'search']">
        </app-autocomplete>
      </div>
      <div class="d-flex align-items-center " [class.order-md-0]="!compact">
        <i class="fa fa-search fs-lg ml-md-2 mr-2 " [class.mr-md-0]="!compact"></i>
      </div>
    </div>
    <ng-container *ngIf="showLocation">
      <div class="border-bottom" [class.d-md-none]="!compact"></div>
      <div class="d-none mr-1 border-right " [class.d-md-block]="!compact"></div>
      <div class="d-flex align-items-center pr-1 p-1 pointer no-wrap-ellipsis " [class.w-md-50]="!compact"
        [class.border-md-right]="!compact">
        <app-location #locationSelector name="location" class="no-border no-shadow" [(ngModel)]="location"
          appendResultsTo="body" [placeholder]="locationPlaceholder" [accept-level]="0" [searchIcon]="false"
          [clearIcon]="false" class="no-border no-shadow" (ngModelChange)="search('location',$event)"
          [max-suggest]="10">
        </app-location>
        <i class="fa fa-crosshairs fs-lg mr-2"></i>
      </div>
    </ng-container>
  </div>
  <div class="w-100 d-flex overflow-hidden mt-1" *ngIf="true || showPageLinks">
    <div class="flex-grow-1 d-flex gap-3 overflow-x-auto scroll-hidden px-1">
      <a class="no-wrap py-1" *ngFor="let link of pageLinks" [attr.data-path]="link.path"
        [routerLink]="[link.path, Utility.removeEmpty({q: value.q, l: value.l})]"
        routerLinkActive="fw-bold border-bottom border-2 border-dark-gray scroll-into-view">
        {{link.title}}<span *ngIf="link.new" class="fs-xs f-red">[جدید]</span>
      </a>
    </div>
    <div class="d-flex align-items-center white-bg px-1 border-right" *ngIf="showFilters">
      <span class="badge badge-pill p-2 pointer disable-selection" [ngClass]="{'light-gray-bg': showFilterBar}"
        (click)="showFilterBar=!showFilterBar">فیلترها</span>

    </div>
  </div>
  <div
    class="d-flex {{wrapFilters ? 'flex-wrap' : 'no-wrap'}} fs-sm overflow-x-auto {{Utility.mobile ? 'scroll-hidden' : 'scroll-md'}}"
    *ngIf="showFilters && showFilterBar">
    <i class="fa fa-arrow-down f-gray order-0 align-self-center pointer" (click)="wrapFilters=!wrapFilters"
      *ngIf="isAdmin"></i>
    <div class="order-1 border-left border-2 my-1"></div>

    <ng-container *ngIf="searchType == 'job'">
      <ng-container *ngIf="isAdmin">
        <div *ngIf="location?.State"
          class="px-1 {{value.hasState ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl pointer m-1 order-{{value.hasState?'0':'2'}}"
          (click)="value.hasState ? removeFilter('hasState') : setFilter('hasState', 'true')">
          حذف سراسر کشور
        </div>
        <div
          class="px-1 {{value.hasEmployer ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl pointer m-1 order-{{value.hasEmployer?'0':'2'}}"
          (click)="value.hasEmployer ? removeFilter('hasEmployer') : setFilter('hasEmployer', 'true')">
          اختصاصی
        </div>
        <select *ngIf="value.hasEmployer"
          class="not-styled {{value.karpasha ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl d-block text-center m-1 order-{{value.karpasha?'0':'2'}}"
          [ngModel]="value.karpasha" (ngModelChange)="setFilter('karpasha', $event)">
          <option [ngValue]="undefined">{{value.karpasha ? 'مهم نیست': 'کارپاشا'}}</option>
          <option value="00000000-0000-0000-0000-000000000000">بدون کارپاشا</option>
          <option *ngFor="let item of operators" [value]="item.Id">{{item.Name || item.Username}}</option>
        </select>
        <div
          class="px-1 {{value.promoted ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl pointer m-1 order-{{value.promoted?'0':'2'}}"
          (click)="value.promoted ? removeFilter('promoted', 'true') : setFilter('promoted', 'true')">
          شرکت معتبر
        </div>
        <select
          class="not-styled {{value.rank ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl d-block text-center m-1 order-{{value.rank?'0':'2'}}"
          [ngModel]="value.rank" (ngModelChange)="setFilter('rank', $event)">
          <option [ngValue]="undefined">{{value.rank ? 'مهم نیست': 'ستاره'}}</option>
          <option [ngValue]="'0'">بدون ستاره</option>
          <option [ngValue]="'5'">5</option>
          <option [ngValue]="'4'">4</option>
          <option [ngValue]="'3'">3</option>
          <option [ngValue]="'2'">2</option>
          <option [ngValue]="'1'">1</option>
        </select>

      </ng-container>
      <div
        class="px-1 {{value.remote ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl pointer m-1 order-{{value.remote?'0':'2'}}"
        (click)="value.remote ? removeFilter('remote', 'true') : setFilter('remote', 'true')">
        دورکاری
      </div>
      <select
        class="not-styled {{value.g ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl d-block text-center m-1 order-{{value.g?'0':'2'}}"
        [ngModel]="value.g" (ngModelChange)="setFilter('g', $event)">
        <option [ngValue]="undefined">{{value.g ? 'مهم نیست': 'جنسیت'}}</option>
        <option [ngValue]="'1'">خانم</option>
        <option [ngValue]="'0'">آقا</option>
      </select>
      <div
        class="px-1 {{value.noexp ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl pointer m-1 order-{{value.noexp?'0':'2'}}"
        (click)="value.noexp ? removeFilter('noexp', 'true') : setFilter('noexp', 'true')">
        بدون نیاز به سابقه
      </div>
      <div
        class="px-1 {{value.insurance ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl pointer m-1 order-{{value.insurance?'0':'2'}}"
        (click)="value.insurance ? removeFilter('insurance', 'true') : setFilter('insurance', 'true')">
        با بیمه
      </div>
      <select
        class="not-styled {{value.sal ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl d-block text-center m-1 order-{{value.sal?'0':'2'}}"
        [ngModel]="value.sal" (ngModelChange)="setFilter('sal', $event)">
        <option [ngValue]="undefined">{{value.sal ? 'مهم نیست': 'میزان حقوق'}}</option>
        <option value="2000000">حقوق بالای 2 میلیون</option>
        <option value="4000000">حقوق بالای 4 میلیون</option>
        <option value="7000000">حقوق بالای 7 میلیون</option>
        <option value="10000000">حقوق بالای 10 میلیون</option>
        <option value="15000000">حقوق بالای 15 میلیون</option>
      </select>
      <select
        class="not-styled {{value.jt ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl d-block text-center m-1 order-{{value.jt?'0':'2'}}"
        [ngModel]="value.jt" (ngModelChange)="setFilter('jt', $event)">
        <option [ngValue]="undefined">{{value.jt ? 'مهم نیست': 'نحوه همکاری'}}</option>
        <option>تمام‌وقت</option>
        <option>پاره‌وقت</option>
        <option>پروژه‌ای</option>
        <option>موقت</option>
        <option>کاراموزی</option>
      </select>
      <select
        class="not-styled {{value.edu ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl d-block text-center m-1 order-{{value.edu?'0':'2'}}"
        [ngModel]="value.edu" (ngModelChange)="setFilter('edu', $event)">
        <option [ngValue]="undefined">{{value.edu ? 'مهم نیست': 'تحصیلات'}}</option>
        <option>دیپلم</option>
        <option>کارشناسی</option>
        <option>کارشناسی ارشد</option>
        <option>دکترا</option>
      </select>

      <select *ngIf="location?.City"
        class="not-styled {{value.dist ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl d-block text-center m-1 order-{{value.dist?'0':'2'}}"
        [ngModel]="value.dist" (ngModelChange)="setFilter('dist', $event)">
        <option [ngValue]="undefined">{{value.dist ? 'فقط همین شهر': 'فاصله از شهر'}}</option>
        <option value="10">تا 10 کیلومتر</option>
        <option value="20">تا 20 کیلومتر</option>
        <option value="30">تا 30 کیلومتر</option>
        <option value="50">تا 50 کیلومتر</option>
        <option value="100">تا 100 کیلومتر</option>
      </select>

      <!-- <div class="px-1 {{value.hasState ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl pointer m-1 order-{{value.mb?'0':'2'}}"
      [class.dark-gray-bg]="value.mb" [class.f-yellow]="value.mb" [class.fw-bold]="value.mb"
      (click)="value.mb ? removeFilter('mb', 'true') : setFilter('mb', 'true')">
      امکان امریه
    </div> -->
    </ng-container>
    <ng-container *ngIf="searchType == 'seeker'">
      <ng-container *ngIf="isAdmin">
        <select
          class="not-styled {{value.recruitLead ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl d-block text-center m-1 order-{{value.recruitLead?'0':'2'}}"
          [ngModel]="value.recruitLead" (ngModelChange)="setFilter('recruitLead', $event)">
          <option [ngValue]="undefined">{{value.recruitLead !== undefined ? 'همه': 'تکمیل اطلاعات'}}</option>
          <option value="4">تایید شده</option>
          <option value="3">در انتظار تایید</option>
          <option value="2">در انتظار تکمیل</option>
          <option value="2">در انتظار پرداخت</option>
        </select>
        <select
          class="not-styled {{value.karpashaReg ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl d-block text-center m-1 order-{{value.karpashaReg?'0':'2'}}"
          [ngModel]="value.karpashaReg" (ngModelChange)="setFilter('karpashaReg', $event)">
          <option [ngValue]="undefined">{{value.karpashaReg !== undefined ? 'همه': 'ثبت‌نام'}}</option>
          <option value="agent-registeration">ثبت‌نام جدید</option>
          <option value="karpasha-service">ثبت‌نام قدیم</option>
        </select>
        <select
          class="not-styled {{value.karpashaPaid ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl d-block text-center m-1 order-{{value.karpashaPaid?'0':'2'}}"
          [ngModel]="value.karpashaPaid" (ngModelChange)="setFilter('karpashaPaid', $event)">
          <option [ngValue]="undefined">{{value.karpashaPaid !== undefined ? 'همه': 'پرداخت'}}</option>
          <option [ngValue]="'true'">پرداخت کرده</option>
          <option [ngValue]="'false'">پرداخت نکرده</option>
        </select>
        <select
          class="not-styled {{value.karpasha ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl d-block text-center m-1 order-{{value.karpasha?'0':'2'}}"
          [ngModel]="value.karpasha" (ngModelChange)="setFilter('karpasha', $event)">
          <option [ngValue]="undefined">{{value.karpasha ? 'همه': 'کارپاشا'}}</option>
          <option value="00000000-0000-0000-0000-000000000000">بدون کارپاشا</option>
          <option *ngFor="let item of operators" [value]="item.Id">{{item.Name || item.Username}}</option>
        </select>
        <select
          class="not-styled {{value.guide ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl d-block text-center m-1 order-{{value.guide?'0':'2'}}"
          [ngModel]="value.guide" (ngModelChange)="setFilter('guide', $event)">
          <option [ngValue]="undefined">{{value.guide ? 'همه': 'راهبر'}}</option>
          <option value="00000000-0000-0000-0000-000000000000">بدون راهبر</option>
          <option *ngFor="let item of operators" [value]="item.Id">{{item.Name || item.Username}}</option>
        </select>
        <select
          class="not-styled {{value.update ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl d-block text-center m-1 order-{{value.update?'0':'2'}}"
          [ngModel]="value.update" (ngModelChange)="setFilter('update', $event)">
          <option [ngValue]="undefined">{{value.update ? 'همه': 'بروزرسانی'}}</option>
          <option value="30">یک ماه</option>
          <option value="90">سه ماه</option>
          <option value="180">شش ماه</option>
          <option value="365">یک سال</option>
        </select>
        <div
          class="px-1 {{value.vanguard ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl pointer m-1 order-{{value.vanguard?'0':'2'}}"
          (click)="value.vanguard ? removeFilter('vanguard', 'true') : setFilter('vanguard', 'true')">
          پیشتاز
        </div>
        <div
          class="px-1 {{value.unemployed ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl pointer m-1 order-{{value.unemployed?'0':'2'}}"
          (click)="value.unemployed ? removeFilter('unemployed', 'true') : setFilter('unemployed', 'true')">
          بیکار
        </div>
        <select
          class="not-styled {{value.jt ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl d-block text-center m-1 order-{{value.jt?'0':'2'}}"
          [ngModel]="value.jt" (ngModelChange)="setFilter('jt', $event)">
          <option [ngValue]="undefined">{{value.jt ? 'مهم نیست': 'نحوه همکاری'}}</option>
          <option>تمام‌وقت</option>
          <option>پاره‌وقت</option>
          <option>پروژه‌ای</option>
          <option>موقت</option>
          <option>کاراموزی</option>
        </select>
        <select
          class="not-styled {{value.maxAge ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl d-block text-center m-1 order-{{value.maxAge?'0':'2'}}"
          [ngModel]="value.maxAge" (ngModelChange)="setFilter('maxAge', $event)">
          <option [ngValue]="undefined">{{value.maxAge ? 'مهم نیست': 'حداکثر سن'}}</option>
          <option [ngValue]="'25'">تا 25 سال</option>
          <option [ngValue]="'30'">تا 30 سال</option>
          <option [ngValue]="'35'">تا 35 سال</option>
          <option [ngValue]="'40'">تا 40 سال</option>
          <option [ngValue]="'45'">تا 45 سال</option>
          <option [ngValue]="'50'">تا 50 سال</option>
        </select>
        <div
          class="px-1 {{value.openToWork ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl pointer m-1 order-{{value.openToWork?'0':'2'}}"
          (click)="value.openToWork ? removeFilter('openToWork', 'true') : setFilter('openToWork', 'true')">
          آماده به کار
        </div>
        <select
          class="not-styled {{value.g ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}}  border rounded-xl d-block text-center m-1 order-{{value.g?'0':'2'}}"
          [ngModel]="value.g" (ngModelChange)="setFilter('g', $event)">
          <option [ngValue]="undefined">{{value.g ? 'مهم نیست': 'جنسیت'}}</option>
          <option [ngValue]="'1'">خانم</option>
          <option [ngValue]="'0'">آقا</option>
        </select>

      </ng-container>
    </ng-container>
    <ng-container *ngIf="searchType == 'employer'">
      <ng-container *ngIf="isAdmin">
        <div
          class="px-1 {{value.karbaladAgreed ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl pointer m-1 order-{{value.karbaladAgreed?'0':'2'}}"
          (click)="value.karbaladAgreed ? removeFilter('karbaladAgreed', 'true') : setFilter('karbaladAgreed', 'true')">
          موافق کاربلد
        </div>
        <div
          class="px-1 {{value.promoted ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl pointer m-1 order-{{value.promoted?'0':'2'}}"
          (click)="value.promoted ? removeFilter('promoted', 'true') : setFilter('promoted', 'true')">
          شرکت معتبر
        </div>
        <select
          class="not-styled {{value.rank ? 'dark-gray-bg f-yellow fw-bold' : 'x-light-gray-bg'}} border rounded-xl d-block text-center m-1 order-{{value.rank?'0':'2'}}"
          [ngModel]="value.rank" (ngModelChange)="setFilter('rank', $event)">
          <option [ngValue]="undefined">{{value.rank ? 'مهم نیست': 'ستاره'}}</option>
          <option [ngValue]="'0'">بدون ستاره</option>
          <option [ngValue]="'5'">5</option>
          <option [ngValue]="'4'">4</option>
          <option [ngValue]="'3'">3</option>
          <option [ngValue]="'2'">2</option>
          <option [ngValue]="'1'">1</option>
        </select>

      </ng-container>
    </ng-container>

  </div>
</div>
<a class="text-center mt-2 d-block" *ngIf="isHomePage" [routerLink]="['/job',urlParams.params]"
  [queryParams]="urlParams.queryParams">
  <button class="btn btn-primary" [class.w-100]="Utility.mobile">جستجوی فرصت‌های شغلی</button>
</a>